export function clearTransaction() {
    return {
        type: 'CLEAR_TRANSACTION',
        payload: ''
    }
}


// WEBPACK FOOTER //
// ./src/user/actions/transactions/Clear.js